import ContentLoader from 'react-content-loader';

import { useSkeletonColors } from 'hooks';

export default function ServicePlanSubscriptionInvoiceLoader() {
  const skeletonColors = useSkeletonColors();

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height="908px"
      {...skeletonColors}
    >
      <rect x="0" y="0" rx="3" ry="3" width="100%" height="92px" />
      <rect x="0" y="108" rx="3" ry="3" width="100%" height="92px" />
      <rect x="0" y="216" rx="3" ry="3" width="100%" height="92px" />
    </ContentLoader>
  );
}
